import {
  allConversionCPAColumn,
  allConversionRateColumn,
  allConversionRevenueOnAdSpendColumn,
  allConversionsColumn,
  averageCPCColumn,
  averageCPMColumn,
  clicksColumn,
  conversionRateColumn,
  conversionsColumn,
  CPAColumn,
  CTRColumn,
  impressionsColumn,
  advertiserReportedRevenue,
  returnOnAdSpendColumn,
  spendColumn,
  averageCPSColumn,
  salesCountColumn
} from '@bingads-webui-grid/well-known';

export const legacyI18nOfListingGroup = {
  Schema_PerformanceMetrics_Property_Impressions: impressionsColumn.name,
  Schema_PerformanceMetrics_Property_Clicks: clicksColumn.name,
  Schema_PerformanceMetrics_Property_CTR: CTRColumn.name,
  Schema_PerformanceMetrics_Property_Spend: spendColumn.name,
  Schema_PerformanceMetrics_Property_AverageCPC: averageCPCColumn.name,
  Schema_PerformanceMetrics_Property_AverageCPM: averageCPMColumn.name,
  Schema_PerformanceMetrics_Property_Conversions: conversionsColumn.name,
  Schema_PerformanceMetrics_Property_ConversionRate: conversionRateColumn.name,
  Schema_PerformanceMetrics_Property_RevenueOnAdSpend: returnOnAdSpendColumn.name,
  Schema_PerformanceMetrics_Property_AdvertiserReportedRevenue: advertiserReportedRevenue.name,
  Schema_PerformanceMetrics_Property_CPA: CPAColumn.name,
  Schema_PerformanceMetrics_Property_AllConversions: allConversionsColumn.name,
  Schema_PerformanceMetrics_Property_AllConversionRate: allConversionRateColumn.name,
  Schema_PerformanceMetrics_Property_AllConversionRevenueOnAdSpend: allConversionRevenueOnAdSpendColumn.name,
  Schema_PerformanceMetrics_Property_AllConversionAdvertiserReportedRevenue: advertiserReportedRevenue.name,
  Schema_PerformanceMetrics_Property_AllConversionCPA: allConversionCPAColumn.name,
  Schema_PerformanceMetrics_Property_AverageCPS: averageCPSColumn.name,
  Schema_PerformanceMetrics_Property_SalesCount: salesCountColumn.name,
  Schema_PerformanceMetrics_Property_ViewThroughConversions: _TL_('View-through conv.'),
  Schema_PerformanceMetrics_Property_ViewThroughConversionsRevenue: _TL_('View-through conv. revenue'),
  Schema_PerformanceMetrics_Property_ViewThroughConversionsCPA: _TL_('View-through conv. CPA'),
  Schema_PerformanceMetrics_Property_ViewThroughConversionsReturnOnAdSpend: _TL_('View-through conv. return on ad spend'),
  Schema_PerformanceMetrics_Property_ViewThroughConversionsRate: _TL_('View-through conv. rate'),
  ProductsGrid_Column_All: _TL_('All products'),
  ProductsGrid_Column_Brand: _TL_('Brand'),
  ProductsGrid_Column_Category1: _TL_('Category (1st level)'),
  ProductsGrid_Column_Category2: _TL_('Category (2nd level)'),
  ProductsGrid_Column_Category3: _TL_('Category (3rd level)'),
  ProductsGrid_Column_Category4: _TL_('Category (4th level)'),
  ProductsGrid_Column_Category5: _TL_('Category (5th level)'),
  ProductsGrid_Column_CategoryL1: _TL_('Category (1st level)'),
  ProductsGrid_Column_CategoryL2: _TL_('Category (2nd level)'),
  ProductsGrid_Column_CategoryL3: _TL_('Category (3rd level)'),
  ProductsGrid_Column_CategoryL4: _TL_('Category (4th level)'),
  ProductsGrid_Column_CategoryL5: _TL_('Category (5th level)'),
  ProductsGrid_Column_Channel: _TL_('Channel'),
  ProductsGrid_Column_ChannelExclusivity: _TL_('Channel Exclusivity'),
  ProductsGrid_Column_Condition: _TL_('Condition'),
  ProductsGrid_Column_CountryOfSale: _TL_('Country/region of sale'),
  ProductsGrid_Column_CustomLabel0: _TL_('Custom label 0'),
  ProductsGrid_Column_CustomLabel1: _TL_('Custom label 1'),
  ProductsGrid_Column_CustomLabel2: _TL_('Custom label 2'),
  ProductsGrid_Column_CustomLabel3: _TL_('Custom label 3'),
  ProductsGrid_Column_CustomLabel4: _TL_('Custom label 4'),
  ProductsGrid_Column_GTIN: _TL_('GTIN'),
  ProductsGrid_Column_Id: _TL_('Item ID'),
  ProductsGrid_Column_Language: _TL_('Language'),
  ProductsGrid_Column_MerchantId: _TL_('Merchant identifier'),
  ProductsGrid_Column_MPN: _TL_('MPN'),
  ProductsGrid_Column_Price: _TL_('Price'),
  ProductsGrid_Column_ProductBought: _TL_('Product Bought'),
  ProductsGrid_Column_ProductType1: _TL_('Product type (1st level)'),
  ProductsGrid_Column_ProductType2: _TL_('Product type (2nd level)'),
  ProductsGrid_Column_ProductType3: _TL_('Product type (3rd level)'),
  ProductsGrid_Column_ProductType4: _TL_('Product type (4th level)'),
  ProductsGrid_Column_ProductType5: _TL_('Product type (5th level)'),
  ProductsGrid_Column_Title: _TL_('Title'),
};

